var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 19.0006C24.571 19.0006 25.758 18.5089 26.6332 17.6338C27.5083 16.7586 28 15.5716 28 14.3339C28 13.0962 27.5083 11.9093 26.6332 11.0341C25.758 10.1589 24.571 9.66725 23.3333 9.66725H22C22.1945 8.80053 22.1975 7.9078 22.0087 7.04005C21.8199 6.17229 21.4431 5.3465 20.8997 4.60982C20.3563 3.87315 19.657 3.24001 18.8417 2.74656C18.0264 2.25311 17.1112 1.90902 16.1481 1.73392C15.1851 1.55882 14.1932 1.55616 13.229 1.72607C12.2648 1.89598 11.3473 2.23515 10.5288 2.72421C8.87567 3.7119 7.72623 5.25016 7.33332 7.00059C5.91192 6.94365 4.51404 7.36112 3.37901 8.18152C2.24399 9.00192 1.44242 10.1742 1.11155 11.4977C0.78068 12.8212 0.941092 14.2135 1.56532 15.4363C2.18955 16.6591 3.23876 17.6363 4.53332 18.2006",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.334V24.334",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.334L14 24.334L18 20.334",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownloadIcon);
export default __webpack_public_path__ + "static/media/cloud-download-icon.209eba3e497e5daf39b64ce70c6b6aef.svg";
export { ForwardRef as ReactComponent };